import React from 'react';
import { ContactCardsBlockRecord } from '~/config/generated/graphql';
import styled from 'styled-components';
import ContactDepartmentCard from './ContactDepartmentCard';
import ContactPersonCard from './ContactPersonCard';
import { mq } from '@kvdbil/components';

const FullWidthContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const MultiItemsContainer = styled.div`
  display: grid;
  gap: 1rem;

  ${mq('tablet')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mq('laptop')} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

type Props = {
  record: ContactCardsBlockRecord;
};

const ContactCards = ({ record }: Props) => {
  const { items, fullWidth } = record;
  const Container = fullWidth ? FullWidthContainer : MultiItemsContainer;
  return (
    <Container>
      {items?.map((item, key) => {
        switch (item.__typename) {
          case 'ContactDepartmentCardRecord':
            return <ContactDepartmentCard key={item.id ?? key} item={item} />;
          case 'ContactPersonCardRecord':
            return <ContactPersonCard key={item.id ?? key} item={item} />;
          default:
            return null;
        }
      })}
    </Container>
  );
};

export default ContactCards;
